import {
    justLog,
    Console,
    JustEatLoggingService
} from '@justeat/just-log';

export default ({ store, isDev }, inject) => {
    const { settings, clientVersion, environment } = store.state.configuration;
    const { tenant } = store.state.globalisation;

    justLog.forFeature({
        name: 'coreweb',
        tenant,
        version: clientVersion,
        environment
    });

    if (isDev) {
        justLog.to(new Console());
    } else {
        justLog.to(new JustEatLoggingService(settings.loggingUrl));
    }

    inject('justLog', justLog);
};
